import React from "react";
import styled from "styled-components";

// Imported components
import PrimaryButton from "./ui/PrimaryButton";

// Styled components
const ButtonGroup = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin-bottom: 10px;
  margin-left: 20px;
  width: 100%;

  & * {
    font-size: 12px;
  }
`;

const CancelButton = styled(PrimaryButton)`
  background: var(--terbine-blue);
`;

const ConfirmButton = styled(PrimaryButton)`
  color: black;
  background: white;
  outline: 1px solid black;
`;

const DialogContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const DialogHeader = styled.h2``;

interface ModalProps {
  $isOpen?: boolean;
}

const Modal = styled.div<ModalProps>`
  background-color: white;
  border-radius: 15px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  display: ${({ $isOpen }) => ($isOpen ? "flex" : "none")};
  flex-direction: row;
  left: 50%;
  max-height: 80%;
  max-width: 80%;
  overflow-y: auto;
  padding: 20px;
  position: fixed;
  top: 50%;
  transform: translate(-50%, -50%);
  width: auto;
  z-index: 110;
`;

interface OverlayProps {
  $isOpen?: boolean;
}

const Overlay = styled.div<OverlayProps>`
  background-color: rgba(0, 0, 0, 0.5);
  display: ${({ $isOpen }) => ($isOpen ? "block" : "none")};
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 109;
`;

const ResetDatabaseDialog = ({ handleReset, isModalOpen, toggleModal }) => {
  return (
    <>
      <Overlay $isOpen={isModalOpen} onClick={toggleModal} />

      <Modal $isOpen={isModalOpen} id="modal">
        <DialogContainer>
          <DialogHeader>Reset Status?</DialogHeader>
          <ButtonGroup>
            <CancelButton onClick={toggleModal} type="button">
              No, cancel
            </CancelButton>
            <ConfirmButton onClick={handleReset} type="button">
              Yes, confirm
            </ConfirmButton>
          </ButtonGroup>
        </DialogContainer>
      </Modal>
    </>
  );
};

export default ResetDatabaseDialog;
